module.exports = __webpack_public_path__ + "img/SER-A-3-IV.7f1331a7.png";